import type { Field } from "@fobu/schema";
import { useFormEnv } from "../lib/context";
import { t } from "../lib/i18n";
import { FieldShell } from "./FieldShell";
import type { A11y } from "./fields/types";
import { Control } from "./Control";

function hintFor(field: Field): string | undefined {
  // Nur bei echten Grenzen – „Mehrfachauswahl möglich“ zeigen die Kästchen schon selbst.
  if (field.type === "multiple_choice" && (field.minSelected !== undefined || field.maxSelected !== undefined)) return t.chooseMany(field.minSelected, field.maxSelected);
  return undefined;
}

export function FieldView({ field, large, number }: { field: Field; large?: boolean; number?: number }) {
  const { ctl } = useFormEnv();
  return (
    <FieldShell field={field} issues={ctl.errors[field.id]} large={large} number={number} hint={hintFor(field)}>
      {(a11y: A11y) => (
        <Control
          field={field}
          value={ctl.answers[field.id]}
          onChange={(v) => ctl.setAnswer(field.id, v)}
          a11y={a11y}
          conversational={ctl.conversational}
          onAdvance={ctl.requestAdvance}
        />
      )}
    </FieldShell>
  );
}
